import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";

const InfoPhiloImage = () => {
  const [src, setSrc] = useState<string | null>(null);


  useEffect(() => {
    const loadImage = async () => {
      const res = await axiosInstance.get('/image');

      const folder = res.data.find(
        (f: any) => f.name === 'philo'
      );

      if (!folder?.files || folder.files.length === 0) return;

      // ✅ on prend la première image (triée)
      const file = folder.files.sort()[0];

      setSrc(
        `${import.meta.env.VITE_BACKEND_URL}/images/philo/${file}`
      );
    };

    loadImage();
  }, []);


  if (!src) return null;

  return (
    <div className="info-philo-image">
      <img
        src={src}
        alt="Philosophie de l'école de cirque"
        loading="lazy"
      />
    </div>
  );
};

export default InfoPhiloImage;